import { render, staticRenderFns } from "./AnomalyDuplicateAssignments.vue?vue&type=template&id=22487d31&"
import script from "./AnomalyDuplicateAssignments.vue?vue&type=script&lang=js&"
export * from "./AnomalyDuplicateAssignments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports